import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Set global backend URL BEFORE any component loads
// This MUST be set before App imports to ensure all components use correct URL
const getBackendUrl = () => {
  const hostname = window.location.hostname;
  if (hostname === 'mis.nifpcmc.com') {
    return 'https://mis.nifpcmc.com';
  }
  return process.env.REACT_APP_BACKEND_URL || window.location.origin;
};
window.BACKEND_URL = getBackendUrl();
console.log("Backend URL initialized:", window.BACKEND_URL);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
